"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const styled_components_1 = __importDefault(require("styled-components"));
const IntakeTableHeader_1 = __importDefault(require("./IntakeTableHeader"));
const card_1 = require("../../molecules/card");
const card_row_divided_1 = require("../../atoms/card-row-divided");
const typography_1 = require("../../shared/typography");
const renderHormone = (values) => {
    const elements = [];
    for (const [key, value] of values.entries()) {
        elements.push((0, jsx_runtime_1.jsxs)(typography_1.H4, { children: ["\u00A0", key.toUpperCase(), " ", `(${value})`] }, void 0));
    }
    return (0, jsx_runtime_1.jsx)("div", { children: elements }, void 0);
};
const renderBodyCharacteristic = (bodyCharacteristic, translations) => {
    const elements = [];
    for (const key in bodyCharacteristic) {
        elements.push((0, jsx_runtime_1.jsx)("div", { children: (0, jsx_runtime_1.jsxs)(typography_1.H4, { children: [`${translations.bodyCharacteristic[key]}: `, " ", `${bodyCharacteristic[key]}`] }, void 0) }, void 0));
    }
    return (0, jsx_runtime_1.jsx)(BodyCharacteristicWrapper, { children: elements }, void 0);
};
exports.default = (0, react_1.memo)(({ translations, intake, tableName, sortHormoneAndDist }) => {
    return ((0, jsx_runtime_1.jsx)(card_1.CollapsableCard, { header: (0, jsx_runtime_1.jsx)(IntakeTableHeader_1.default, { title: tableName }, void 0), children: (0, jsx_runtime_1.jsxs)(Wrapper, { children: [(0, jsx_runtime_1.jsx)(card_row_divided_1.CardRowDivided, { left: (0, jsx_runtime_1.jsx)(typography_1.P, { children: translations.disc }, void 0), right: renderHormone(sortHormoneAndDist(intake.disc)) }, void 0), (0, jsx_runtime_1.jsx)(card_row_divided_1.CardRowDivided, { left: (0, jsx_runtime_1.jsx)(typography_1.P, { children: translations.nutritionExperiencePoint }, void 0), right: (0, jsx_runtime_1.jsx)(typography_1.H4, { children: intake.nutritionExperience }, void 0) }, void 0), (0, jsx_runtime_1.jsx)(card_row_divided_1.CardRowDivided, { left: (0, jsx_runtime_1.jsx)(typography_1.P, { children: translations.trainingExperiencePoint }, void 0), right: (0, jsx_runtime_1.jsx)(typography_1.H4, { children: intake.trainingExperience }, void 0) }, void 0), (0, jsx_runtime_1.jsx)(card_row_divided_1.CardRowDivided, { left: (0, jsx_runtime_1.jsx)(typography_1.P, { children: translations.bodyCharacteristicTitle }, void 0), right: renderBodyCharacteristic(intake.bodyCharacteristics, translations) }, void 0)] }, void 0) }, void 0));
});
const Wrapper = styled_components_1.default.div `
  h4 {
    display: inline-block;
    font-weight: 400;
  }

  p {
    color: ${({ theme }) => theme.colors.greyLighten40};
    margin-bottom: 0;
    margin-right: ${({ theme }) => theme.spacings.m};
    padding-right: ${({ theme }) => theme.spacings.m};
  }

  & > div:not(:last-of-type) {
    border-bottom: 1px solid
      ${({ theme }) => theme.colors.silverLighten40};
  }

  & > div:nth-of-type(4) > div:first-of-type {
    align-self: flex-start;
  }

  & > div > div {
    align-self: flex-end;
  }

  @media (max-width: ${({ theme }) => theme.utils.breakpoints.mobile}) {
    p {
      margin-right: 0;
      padding-right: 0;
    }

    & > div > div:last-of-type {
      flex: 6;
    }
  }
`;
const BodyCharacteristicWrapper = styled_components_1.default.div `
  & > div:not(:last-of-type) {
    display: flex;
    margin-bottom: ${({ theme }) => theme.spacings.xxs};
  }

  h4 {
    margin-bottom: 0;
  }
`;
//# sourceMappingURL=CollapseIntakeWeighting.js.map